module.exports = __webpack_public_path__ + "h5/img/电话.993128a6.png";